
import Multiselect from 'vue-multiselect';

export default {
    name: "FilterDropdownMobile",
    components: {
        Multiselect,
    },
    props: {
        filterTitle: {
            type: String,
            required: true,
            default: '',
        },
        actualValue: {
            required: true,
            // default: () => {},
        },
        filterOptions: {
            type: Array,
            required: true,
            default: () => [],
        },

        mode: {
            type: String,
            required: false,
            default: 'default',
        },

        isMultiple: {
            type: Boolean,
            required: false,
            default: false,
        },
        noTag: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            value: null,
            tempValue: this.mode.includes('show-default-value')
            ? this.actualValue
            : { value: null, text: this.filterTitle, id: null },
            placeholderValue: { value: null, text: this.filterTitle, id: null },
            displayValue: this.isMultiple || this.mode.includes('show-default-value') ? this.actualValue : '',

            filterDataActualValue: this.actualValue,
            isSelected: false,
            storeMode: this.$store.getters['modal/showDisplayMobileFilter'].mode,
            wrapperWidth: 0
        }
    },
    methods: {
        onInput(value) {
            // this.isSelected = true;

            // save to tempValue
            this.tempValue = value;

            // modify actualValue
            this.filterDataActualValue = this.tempValue;
            this.$emit('update:actualValue', this.tempValue);
            
            if (this.displayValue === undefined || this.displayValue?.length === 0) {
                this.isSelected = false;
            }
        },
        handleAdjustSliderWidth() {
            // console.log(this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper'))
            this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper').style.width = `${this.wrapperWidth}px`;
            this.$refs.multiselect.$el.querySelector('.multiselect__tags').style.maxWidth = `60%`;
            if (this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single')) {
                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.width = `65%`;
            }
            if (!this.isMultiple) {
                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.display = `none`;
            }

            // console.log(this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper'))

        },
        handleAdjustSelection() {
            // this.$refs.multiselect.$el.querySelector('.multiselect__tags').style.maxWidth = `85%`;
            if (this.$refs.multiselect.$el.querySelector('.multiselect__content-wrapper').style.display !== 'none') {
                this.$refs.multiselect.$el.querySelector('.multiselect__tags').style.maxWidth = `85%`;

            }
            if (this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single')) {

                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.width = `100%`;
            }
            if (!this.isMultiple) {
                this.$refs.multiselect.$el.querySelector('.multiselect .multiselect__tags .multiselect__single').style.display = `unset`;
            }
        }

    },
    mounted() {
        this.wrapperWidth = this.$refs.filtercontainer.querySelector('.filter-wrapper').offsetWidth;
        // if (this.isMultiple) {
        //     this.$refs.multiselect.$el.querySelector('.multiselect__tags').style.maxWidth = `60%`;
        // }
        this.$nextTick(() => {
            const type = this.mode.split(' ');
            const storeMode = this.$store.getters['modal/showDisplayMobileFilter'].mode;
            if (type[0] == storeMode) {
                this.$refs.multiselect.activate();
            }
        })
    },
    watch: {
        actualValue(newVal) {
            this.displayValue = newVal;
        }
    }
}
